<template>
  <div class="wrapper" id="wap">
    <div class="loginStatus hide">
      <div v-if="name != ''">
        <span class="themeColor">{{name}}</span>
        您好，欢迎来到小白云服！
        <span class="logout" @click="loginOut" style="color: #999999"> 退出</span>
      </div>
      <div v-else class="login"><span @click='goTo("login")'>登录/注册</span></div>
    </div>
    <header class="flex-wrap pageTop hide">
      <div class="flex-start">
        <div class="logo">
          <img src="../../static/images/dutyInsurance/logo.png" alt="小白保险logo" title="小白保险">
        </div>
        <div class="headline flex-end">
          <div class="index" :class="current=='index'?'currentPage':''" @click='goTo("index")'>首页</div>
          <div class="insuranceList" :class="'insuranceList,productShowDetail'.includes(current) ?'currentPage':''" @click='goTo("insuranceList")'>保险产品</div>
          <div class="about" :class="current=='about'?'currentPage':''" @click='goTo("about")'>关于我们</div>
        </div>
      </div>
      <div class="flex-end" style="float: right">
        <div class="personalCenter" @click="personalCenter">
          <img src="../../static/images/home/crown.png" alt="" class="crown" />
          <span class="personal">会员中心</span>
        </div>
        <div style="padding: 0 .5rem">|</div>
        <div>客服电话：<span style="color: #F2613F">020-82526981</span></div>
      </div>
    </header>
    <main class="contentModule">
      <transition name="router-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
    <footer class="footerUnit hide">
      <div class="introduction">
        <div class="aboutInfo space-between">
          <div class="aboutTitle">关于我们</div>
          <div class="aboutList">
            公司简介<span> | </span>专业服务<span> | </span>联系我们
          </div>
        </div>
        <div class="xiaoBaiInfo space-between">
          <div>
            <div>微博名：小白保险网</div>
            <div>微信号：xiaobaibao05</div>
            <div>邮箱：kf@xiaobiaobao.com</div>
            <div>电话：020-82526981</div>
          </div>
          <div class="flex-start QRCode">
            <div>
              <img src="../../static/images/home/AppQRCode.png">
              <div>小白宝安卓下载</div>
            </div>
            <div>
              <img src="../../static/images/home/AppQRCode.png">
              <div>小白宝苹果下载</div>
            </div>
            <div>
              <img src="../../static/images/home/serviceQrCode.png">
              <div>小白宝公众号</div>
            </div>
          </div>
        </div>
      </div>
      <div class="space-between bottomInfo">
        <div>
          <div>
            <span>版权所有：正迅保险经纪有限公司</span>
            <span>联系电话：020-82526981</span>
            <span>地址：广州市黄埔区开创大道2403号1003室</span>
          </div>
          <div>粤ICP备13035223号3</div>
        </div>
        <div class="tips">
          图片及文字免责声明
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import $$ from "../tool/BaseXJT";
  export default {
    name: "wap",
    data() {
      return {
        current: 'index',
        name: '',
      }
    },
    methods:{
      goTo(title){
        this.current = title;
        if (this.$route.path == '/vue/insureManagement') $('.insuranceList').toggleClass('insure');
        if (title == 'login'){
          if (this.$route.name == 'login') return;
          this.$router.push({name: `${title}`, query: { returnUrl: window.location.href }});
        }else {
          this.$router.push({name: `${title}`});
        }
      },
      getUserInfo() {
        let that = this;

        // that.axios.post(that.UrlConfig.member_member_detailsPageMember).then((response) => {
        //   if (response.data.success){
        //     let {account, imgPath, rname ,id} = response.data.datas;
        //     $('.account').html(account);
        //       localStorage.setItem("memberId", id);
        //     if (that.$$.isValidObj(imgPath)) $('.imgPath').attr('src', imgPath) ;
        //     that.name = that.$$.isValidObj(rname) ? rname : account;
        //   } else {
        //     localStorage.removeItem(that.$$.constant.tokenKey + '_TIMING');
        //   }
        // });

        that.$$.request({
            url: that.UrlConfig.member_member_detailsPageMember,
            loading: true,
            sfn: function (data) {
              that.$$.closeLoading();
              if (data.success) {
                let {account, imgPath, rname ,id} = data.datas;
                // $('.account').html(account);
                localStorage.setItem("memberId", id);
                if (that.$$.isValidObj(imgPath)) $('.imgPath').attr('src', imgPath) ;
                that.name = that.$$.isValidObj(rname) ? rname : account;
              } else {
                localStorage.removeItem(that.$$.constant.tokenKey + '_TIMING');
                that.$message.error(data.msg);
              }
            },
            ffn: function (data) {
              that.$$.errorHandler();
            }
        });
      },
      //-- 用户中心
      personalCenter() {
        this.$router.push('/wapPage');
      },
      //-- 退出登录
      loginOut() {
        let that = this;
        that.axios.post('/member/member/memberLoginOut?terminal=1').then((response) => {
          if (response.data.success == true){
            localStorage.removeItem(that.$$.constant.tokenKey + '_TIMING');
            that.axios.defaults.headers.common[that.$$.constant.tokenKey] = null;

            that.$message.success('退出成功~');
            that.name = '';
            that.$router.push({name: `index`});
          }else {
            this.$message.error(response.data.msg);
          }
        });
      },
      //-- 自动登录
      login() {
        let that = this;
        that.axios.post('/auth/member/accredit?username=18302047033&password=abc123&ltype=1&terminal=1').then((response) => {
          let data = response.data;
          const token = data[that.$$.constant.tokenKey];

          that.$$.localStorageSet(that.$$.constant.tokenKey + '_TIMING', token);
          window.location.href = that.rootUrl;
          //window.location.href = 'https://xbyftest.xiaobaibao.com/vue/#/vue'  // 测试
        });
      },
    },
    mounted() {
      let that = this,
        path = this.$route.path,
        name = path.substring(path.lastIndexOf("/")+1);
      if (this.$$.isValidObj(name)){
        let insureList = 'insureManagement,insureDetails,insureConfirm,orderPaymentType',
          sskList = 'sskProductDetailPage,sskInfoFillingPage,sskGuaranteeDetailPage,zfbProductDetailPage,zfbInfoFillingPage',
          hideList = 'sinosafeInsureManagement,siNoSafeInsureDetails,siNoSafeOrderDetails,siNoSafeInsureConfirm';

        if (insureList.includes(name)) $('.insuranceList').removeClass('insure');
        if (!hideList.includes(name)) $('.pageTop, .loginStatus, .footerUnit').removeClass('hide');

        if (sskList.includes(name)){
          $('.pageTop, .loginStatus, .footerUnit').addClass('hide');
        }
      }else {
        $('.pageTop, .loginStatus, .footerUnit').removeClass('hide');
      }


      this.current = this.$route.name;

      /*let token = this.$$.localStorageGet($$.constant.tokenKey + '_TIMING');
      if (this.$$.isValidObj(token)) {
        if (token != null) this.getUserInfo();
      }else {
        this.login();
      }*/

      let token = this.$$.localStorageGet($$.constant.tokenKey + '_TIMING');
      if (token != null) this.getUserInfo();

      // this.$$.alert({message: "请求未带标识，token不能为空!", confirmText: '知道'});
      // this.$message.error("投保单位不能为空!");
      // that.$$.confirm({
      //   message: "您还未登录，是否登录？",
      //   type: 'error',
      //   onOk: function () {
      //     // that.goTo('login');
      //   },
      // });
      // that.$$.loading();
      // that.$$.throwTips("登录失败，请检查账号密码是否输入正确！");
      // console.log(that.$$.getTimeStamp(new Date('2022-5-11')));
      // that.$$.errorHandler();
    },
  }
</script>

<style scoped>
  .contentModule{
    height: 100%;
    width: 100%;
    background: #FFFFFF;
  }

  .contentModule>section{
    width: auto;
    margin: 0 auto;
  }

  .insure{
    color: #ffffff;
  }

  .hide{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/wap.vue